import './accessibility-debug.css'
import { AccessibilityDebugElement } from './AccessibilityDebugElement'

customElements.define('accessibility-debug', AccessibilityDebugElement)
